import type { FaireProductEntity } from "../../entity_types/product";

export const p_utmw7h67yd: FaireProductEntity = {
  token: "p_utmw7h67yd",
  type: "product",
  name: "I Love Jesus Metal Plaque Pu Leather Key Chain",
  brandName: "Cap Zone",
  imageUrl:
    "https://cdn.faire.com/fastly/ba2090c25f60cab66672649269c64f3dee023efcb6b64b569b214d57e413544e.jpeg",
  priceDollars: 0.85,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/d80c5dd4f4d9cd4e82e2939a589345b8981f763dc735d4d0eed068c0c5260c66.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
